"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaAccountFactory = void 0;
const Factory = require("factory.ts");
const Accounts_1 = require("../Accounts");
exports.personaAccountFactory = Factory.Sync.makeFactory({
    id: `persona-account-${Factory.each(i => i + 1)}`,
    access: 'viewer',
    relationship: 'other',
    persona_listener_id: null,
    user: Accounts_1.userFactory.build()
});
